var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8749_3158",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8749_3158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 91.6667V74.375L32.2916 87.7084L26.4583 81.875L45.8333 62.5V54.1667H37.4999L18.1249 73.5417L12.2916 67.7084L25.6249 54.1667H8.33325V45.8334H25.6249L12.2916 32.2917L18.1249 26.4584L37.4999 45.8334H45.8333V37.5L26.4583 18.125L32.2916 12.2917L45.8333 25.625V8.33337H54.1666V25.625L67.7083 12.2917L73.5416 18.125L54.1666 37.5V45.8334H62.4999L81.8749 26.4584L87.7083 32.2917L74.3749 45.8334H91.6666V54.1667H74.3749L87.7083 67.7084L81.8749 73.5417L62.4999 54.1667H54.1666V62.5L73.5416 81.875L67.7083 87.7084L54.1666 74.375V91.6667H45.8333Z",
    fill: "#0000FF"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAc);
export default __webpack_public_path__ + "static/media/ac.a641c02cbd43006d74bdb7950296f425.svg";
export { ForwardRef as ReactComponent };